/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { DocumentDetailsPictAction, DocumentDetailsPictActionType } from '../actions/documentDetailsPictActions';

export interface DocumentDetailsPictState {
    isLoading: boolean;
    documentPict: ArrayBuffer;
}

const initialState: DocumentDetailsPictState = {
    isLoading: false,
    documentPict: null,
};

function documentDetailsPictReducer(
    state: DocumentDetailsPictState = initialState,
    action: DocumentDetailsPictAction,
): DocumentDetailsPictState {
    switch (action.type) {
        case DocumentDetailsPictActionType.OPEN_DOCUMENT_CARD_PICT_PAGE:
        case DocumentDetailsPictActionType.FETCH_DOCUMENT_PICT_START:
            return {
                ...state,
                isLoading: true,
            };

        case DocumentDetailsPictActionType.FETCH_DOCUMENT_PICT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                documentPict: action.payload,
            };

        case DocumentDetailsPictActionType.FETCH_DOCUMENT_PICT_ERROR:
            return {
                ...state,
                isLoading: false,
            };

        case DocumentDetailsPictActionType.EXIT_DOCUMENT_CARD_PICT_PAGE:
            return {
                ...state,
                isLoading: false,
                documentPict: null,
            };

        default:
            return state;
    }
}

export default documentDetailsPictReducer;
